
export function debounce(fn, delay, immediate = true) {
  let timer = null;
  return function(...args) {
    if(!timer && immediate) fn(...args);
    if(timer) clearTimeout(timer);
    timer = setTimeout(() => {fn(...args); timer = null;}, delay);
  };
}